<div class="footer-container" [class.signed-out]="(isSignedIn$ | async) === false">
  <div class="animate-expansion" [class.expanded]="accountInfoExpanded">
    <div>
      <div class="text-center email-address flex flex-col align-items-center rounded-t-sm" *ngIf="isSignedIn$ | async">
        <span class="user-initials bg-n-40 rounded-[50%] w-6 h-6 flex place-items-center place-content-center text-white font-hiroMono text-[12px] mb-2">
          {{ (email$ | async)?.substring(0, 1)?.toUpperCase() }}
        </span>
        <p class="mt-0">
          <yat-email-clip id="e239d65d-b0d8-4ca5-9eac-2beed6875e5d" [email]="email$ | async"> </yat-email-clip>
        </p>
      </div>
      <div class="text-center account-management">
        <p>
          {{ 'layout.bottomRow.whatIsYatta.title' | transloco }}
        </p>
        <p>
          {{ 'layout.bottomRow.whatIsYatta.explanation' | transloco }}
        </p>
        <div class="account-management-actions">
          <a
            yat-link
            class="link link-secondary"
            yatTabSelectable
            [yatExternalLink]="accountUrl$ | async"
            *ngIf="isSignedIn$ | async"
            [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
            matomoClickAction="UserAction"
            matomoClickName="GoToMyAccount">
            <yat-icon id="037635a2-1036-4213-b366-2ac3af2b9d90" name="cog-duo"></yat-icon>
            <span>{{ 'layout.bottomRow.myAccount' | transloco }}</span>
          </a>
          <yat-language-chooser [classNames]="['dropdown-sm', 'dark']"></yat-language-chooser>
          <div
            yat-link
            class="link link-secondary"
            yatTabSelectable
            (tabSelect)="signOut()"
            *ngIf="isSignedIn$ | async"
            [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
            matomoClickAction="Select_SignOut">
            <yat-icon id="8b1caff6-994d-4ce3-8373-84e17a92803b" name="sign-out-duo"></yat-icon>
            <span>{{ 'layout.bottomRow.signOut' | transloco }}</span>
          </div>
        </div>
      </div>
      <div class="border-dotted-container">
        <div class="col-12 border-dotted pb-1"></div>
      </div>
    </div>
  </div>
  <yat-mobile-draw-dialog id="fe86874a-43f3-4804-8038-9e17f34244cf"
    [showDialog]="showDialog && isMobileScreenSize()"
    [isSignedIn]="isSignedIn$ | async"
    [email]="email$ | async"
    (abortConfirmModal)="closeMobileDialog()">
    <ng-container ngProjectAs="primaryMenu">
      <div class="text-center email-address flex flex-col align-items-center" *ngIf="isSignedIn$ | async">
        <span class="user-initials bg-n-40 rounded-[50%] w-6 h-6 flex place-items-center place-content-center text-white font-hiroMono text-[12px] mb-2">
          {{ (email$ | async)?.substring(0, 1)?.toUpperCase() }}
        </span>
        <p class="mt-0">
          <yat-email-clip id="6dcc8d3e-fee9-4be9-812f-09328a674e3c" [email]="email$ | async" class="text-n-40"> </yat-email-clip>
        </p>
      </div>

      <div class="text-center text-n-40 mb-8 px-6 mt-3" *ngIf="!isUmlLabHost">
        <p class="mb-2">
          {{ 'layout.bottomRow.whatIsYatta.title' | transloco }}
        </p>
        <p>
          {{ 'layout.bottomRow.whatIsYatta.explanation' | transloco }}
        </p>
      </div>
      <a yat-link class="link link-secondary" yatTabSelectable [yatExternalLink]="accountUrl$ | async" *ngIf="isSignedIn$ | async">
        <yat-icon id="2ebdc4aa-da12-4bc6-862e-bd574edb2b27" name="cog-duo"></yat-icon>
        <span>{{ 'layout.bottomRow.myAccount' | transloco }}</span>
      </a>
      <yat-language-chooser id="69b22a08-1490-4828-923a-48ba354b07c4"></yat-language-chooser>
      <a yat-link class="link link-secondary" yatTabSelectable (tabSelect)="signOut()" *ngIf="isSignedIn$ | async">
        <yat-icon id="65b379bd-edea-4547-9ec4-86aeff9bb538" name="sign-out-duo"></yat-icon>
        <span>{{ 'layout.bottomRow.signOut' | transloco }}</span>
      </a>
    </ng-container>
  </yat-mobile-draw-dialog>
  <yat-powered-by-footer id="e652f9b7-3032-49ad-b193-810fd9f4c38d" class="footer"></yat-powered-by-footer>
</div>
<div class="text-center expand-collapse-icon-container" [class.expanded]="accountInfoExpanded">
  <div
    *ngIf="!isMobileScreenSize(); else mobileContent"
    [yatTooltip]="
      (accountInfoExpanded
        ? 'layout.bottomRow.minimize'
        : (isSignedIn$ | async)
        ? 'layout.bottomRow.expand.tooltipSignedIn'
        : (showWhatIsYattaHint$ | async)
        ? null
        : 'layout.bottomRow.expand.tooltipSignedOut'
      ) | transloco
    "
    [tooltipPlacement]="['bottom']">
    <p
      yatTabSelectable
      (tabSelect)="expandAccountInformation()"
      *ngIf="(showWhatIsYattaHint$ | async) && !accountInfoExpanded"
      class="text-[12px] leading-base-sm mt-2">
      {{ 'layout.bottomRow.expand.hintForSignUp' | transloco }}
    </p>
    <yat-icon
      yatTabSelectable
      (tabSelect)="expandAccountInformation()"
      name="chevron-down"
      [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
      [matomoClickAction]="accountInfoExpanded ? 'Select_FooterCollapse' : 'Select_Footer_Expand'"></yat-icon>
  </div>
  <ng-template #mobileContent>
    <div>
      <p
        *ngIf="(isSignedIn$ | async) === false"
        yatTabSelectable
        (tabSelect)="showMobileDialog()"
        class="text-[12px] text-n-40 leading-base-sm pb-6 tablet:pb-0">
        {{ 'layout.bottomRow.expand.hintForSignUp' | transloco }}
      </p>
      <yat-icon
        yatTabSelectable
        (tabSelect)="showMobileDialog()"
        name="chevron-down"
        *ngIf="isSignedIn$ | async"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
        matomoClickAction="ExpandCollapse"
        matomoClickName="GoToMyAccount"></yat-icon>
    </div>
  </ng-template>
</div>
